import React from "react";
import { Box, LinearProgress, CircularProgress } from "@mui/material";
import { ClockIcon } from "../Icons/Miscellaneous/ClockIcon";
import "./Progress.scss";

/**
 * @param {number} current - Valor actual del progreso
 * @param {number} total - Valor total del progreso (requerido para variant 'fraction')
 * @param {string} timeRemaining - Tiempo restante (requerido para variant 'detailed')
 * @param {'fraction' | 'percentage' | 'detailed'} variant - Tipo de progress bar
 * @param {'left' | 'right'} textAlign - Alineación del texto en mobile (solo para variant 'fraction')
 * @param {boolean} isLoading - Indica si el progreso está cargando
 * @param {string} className - Clases CSS adicionales
 * @param props - Otros props pasados al componente
 */
export const Progress = ({
  current,
  total,
  timeRemaining,
  variant = "fraction",
  textAlign = "right",
  isLoading = false,
  className = "",
  ...props
}) => {
  const progressValue =
    variant === "percentage" ? current : (current / total) * 100;

  return (
    <Box
      className={`progress-wrapper progress-wrapper--${variant} ${
        variant === "fraction" ? `progress-wrapper--text-${textAlign}` : ""
      } ${className}`}
      {...props}
    >
      {variant === "detailed" && (
        <div className="progress-text paragraph-s-regular">
          {current}% | <ClockIcon /> {timeRemaining}
        </div>
      )}

      <div className="progress-container">
        <LinearProgress
          variant="determinate"
          value={progressValue}
          className="progress-bar"
        />
      </div>

      {variant !== "detailed" && (
        <div className="progress-text-detail paragraph-m-regular">
          {isLoading ? (
            <CircularProgress size={14} />
          ) : (
            <>
              {variant === "fraction" && `${current}/${total}`}
              {variant === "percentage" && `${Math.round(current)}%`}
            </>
          )}
        </div>
      )}
    </Box>
  );
};
